(function (t) {
// fr
t.add("security.reset_password_mail_sent", "Un email avec un lien de r\u00e9initialisation a \u00e9t\u00e9 envoy\u00e9.", "flash_messages", "fr");
t.add("company.user_limit_exceeded", "Limite de comptes disponibles atteinte", "flash_messages", "fr");
t.add("company.user_code_edited", "Code \u00e9dit\u00e9 avec succ\u00e8s ", "flash_messages", "fr");
t.add("company.user_code_added", "Code ajout\u00e9", "flash_messages", "fr");
})(Translator);
